const END_POINTS = {
  AUTH_SET_LOGIN: '/api/User/SetLogin',
  GET_CURRENT_USER: '/api/User/GetCurrentUser',

  // Email template
  GET_EMAIL_TEMPLATE: '/api/EmailTemplate/GetEmailTemplates',
  GET_EMAIL_TEMPLATE_By_ID: '/api/EmailTemplate/GetEmailTemplateById',
  ADD_EMAIL_TEMPLATE: '/api/EmailTemplate/CreateEmailTemplate',
  UPDATE_EMAIL_TEMPLATE: '/api/EmailTemplate/UpdateEmailTemplate',
  DELETE_EMAIL_TEMPLATE: '/api/EmailTemplate/DeleteEmailTemplate',

  // Role
  GET_ROLES: 'api/Role/GetRoles',

  // Analytic
  GET_ANALYTIC_SEARCH: 'api/Analytic/GetSearches',
  GET_ANALYTIC_TOPIC: 'api/Analytic/GetTopics',
  GET_CHART_ANALYTIC_TOPIC: 'api/Analytic/GetTopicsChart',
  GET_ANALYTIC_USER: 'api/Analytic/GetUsers',
  GET_ANALYTIC_EX_USER: 'api/Analytic/GetExUsers',
  GET_USERS_VIEW_ARTICLE_ID: 'api/Analytic/GetUsersViewArticleId',
  GET_ARTICLES_VIEW_USER_ID: 'api/Analytic/GetArticlesViewUserId',
  GET_SEARCH_KEY_WORD: 'api/Search/GetKeywords',
  GET_ARTICLE_TITLE: 'api/Article/GetArticleTitle',
  GET_USER_DISPLAY_NAME: 'api/User/GetUserDisplayName',
  GET_USER_TITLE: 'api/User/GetUserTitle',
  GET_ARTICLE_BY_CONTRIBUTOR: 'api/Article/GetArticleByContributor',
  REPLACE_ARTICLE_CONTRIBUTOR: 'api/Article/ReplacArticleContributor',
  GET_ANALYTIC_FEEDBACKS: 'api/Analytic/GetFeedbacks',
  GET_ANALYTIC_FEEDBACKS_BY_TYPE: 'api/Analytic/GetArticlesByFeedbackType',
  GET_ANALYTIC_LINKS: 'api/Analytic/GetLinks',
  GET_ANALYTIC_LINKS_FILTER: 'api/Analytic/GetLinkReferenceFilter',
  POST_ANALYTIC_UPDATE_LINK: 'api/Analytic/UpdateLink',
  // GET_ARTICLES_BY_LINK_ID: "api/Analytic/GetArticlesByLinkId",
  OVERVIEW_SEARCH: 'api/Analytic/GetOverviewSearch',
  OVERVIEW_ARITICLE: 'api/Analytic/GetOverviewArticle',
  OVERVIEW_USER: 'api/Analytic/GetOverviewUser',
  GET_ARTICLE_LINK_REFERENCE_FILTER: 'api/Analytic/GetArticleLinkReferenceFilter',
  GET_TOPIC_FILTER_CATEGORIES: 'api/Analytic/GetTopicFilterCategories',
  GET_TOPIC_FILTER_DISCIPLINE: 'api/Analytic/GetTopicFilterDiscipline',
  OVERVIEW_TOP_MOST_THUMB_UP: 'api/Analytic/GetOverviewTopTenMostThumbUp',
  OVERVIEW_FEEDBACKS: 'api/Analytic/GetOverviewFeedbacks',
  OVERVIEW_REVIEWS: 'api/Analytic/GetOverviewReviews',

  // Group
  GET_GROUPS: 'api/Group/GetGroups',
  GET_GROUP_OFFICE: 'api/Group/GetOffice365Groups',

  // File
  UPLOAD_FILE: 'api/File/UploadFiles',

  // Review
  GET_REVIEWS: 'api/ArticleReview/GetArticleReviews',
  GET_REVIEWS_BY_ID: 'api/ArticleReview/GetArticleReviewById',
  GET_REVIEWS_FILTER: 'api/ArticleReview/GetArticleReviewFilter',
  APPROVED_ARTICLE_REVIEW: 'api/ArticleReview/ApprovedArticleReview',
  REJECTED_ARTICLE_REVIEW: 'api/ArticleReview/RejectedArticleReview',
  CREATE_ARTICLE_REVIEW: 'api/ArticleReview/CreateVersionArticleReview',
  GET_LIST_VERSION_REVIEW_BY_ID: 'api/ArticleReview/GetListVersionReview',
  GET_HISTORIES_BY_REVIEW_ID: 'api/ArticleReview/GetHistoriesByReviewId',
  GET_OVERDUE_REVIEWS: '/api/Analytic/GetOverviewOverdueReviews',
  GET_UPCOMING_REVIEWS: '/api/Analytic/GetOverviewUpcomingReviews',

  // Searchbar
  GET_TITLE_AND_CONTENT: 'api/Article/GetTitleAndContent',
  COUNT_SEARCH: 'api/Search/Search',
  GET_TITLE: 'api/Analytic/GetArticleFilterToAnalyticLink',

  // User Topic
  GET_ARTICLE_LIKE: 'api/UserSide/GetLikesByArticleId',
  LIKE_ARTICLE: 'api/UserSide/LikeForArticle',
  THUMB_UP_ARTICLE: 'api/Article/ThumbUpArticle',

  // Topics admin
  GET_TOPICS_FILTER_OPTION_USER: 'api/Article/GetArticleFilterFields',

  // Article
  GET_ARTICLE_BY_SLUG_URL: 'api/Article/GetArticleBySlugUrl',
  GET_ARTICLE_PUBLISHED_BY_SLUG_URL: 'api/UserSide/GetArticlePublishedDetailBySlugUrl',
  REJECT_AUTHOR_REVIEW: 'api/Article/RejectAuthorReview',
  APPROVE_AUTHOR_REVIEW: 'api/Article/ApproveAuthorReview',
  UPDATE_ALL_SORT_ORDER_ARTICLE: 'api/UserSide/UpdateAllSortOrderArticle',
  UPDATE_SORT_ORDER_ARTICLE: 'api/UserSide/UpdateSortOrderArticle',

  // Advanced Search
  GET_ALL_ADVANCED_SEARCHES: 'api/Article/GetArticleAdvance'
};

export default END_POINTS;
